'use client';

import { cn } from 'utils/cn';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC, ReactNode } from 'react';
import Typography from '../Typography';
import { factoryMenuActiveRule } from './useMenu';

export interface IMenuItem {
  route: string;
  notCollapsible?: boolean;
  visible: boolean;
  iconActive: ReactNode;
  iconInactive: ReactNode;
  name: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  childrens?: IMenuItem[];
}

const MenuItem: FC<IMenuItem> = ({
  route,
  iconActive,
  iconInactive,
  name,
  visible,
  className = '',
  onClick
}) => {
  const pathname = usePathname();
  const active = factoryMenuActiveRule(route, pathname);

  if (!visible) return null;

  return (
    <Link
      href={route}
      draggable={false}
      className={cn(
        'flex items-center rounded-lg p-2 text-2xl font-normal',
        'text-tertiary-100 hover:bg-gray-100 hover:font-medium ',
        'user-select-none !user-drag-none'
      )}
      onClick={onClick}
    >
      {active ? iconActive : iconInactive}
      <Typography
        variant={active ? 'medium3' : 'light3'}
        className={cn(
          'user-select-none ml-3 h-7 select-none transition-all duration-200 ',
          active ? 'text-tertiary-100' : 'pt-[3px] text-tertiary-300',
          className
        )}
      >
        {name}
      </Typography>
    </Link>
  );
};

export default MenuItem;
